import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
  langUpdateAteLayerAction,
  resetATEAction,
  resetAteListAction,
  resetCurrentsAteAction,
  resetFoundLayerAction,
  setCurrentLayerAction,
} from 'store/actions/layers';
import {
  getToolbarSelectAction,
  needUpdateAction,
  setEmptyStatisticsDataAction,
} from 'store/actions/mainPage';
import { resetDynamicSeries } from 'store/actions/dynamicSeries';
import { ParamName } from 'components/SearchTab/ParamName';
import { AteBlock } from 'components/UI/AteBlock';
import { YearSelect } from 'components/UI/YearSelect';
import { SelectChangeEvent } from '@mui/material';
import {
  resetTransitionData,
  setTransitionsData,
} from '../../../store/actions/transitData';

export const SearchLayersBlock: React.FC = () => {
  const { isLogged, needUpdate } = useAppSelector((state) => state.mainPage);
  const { clusterInfo } = useAppSelector((state) => state.searchTab);
  const { foundPoints } = useAppSelector((state) => state.vectorLayers);
  const { from } = useAppSelector((state) => state.transitData);

  const {
    years,
    currentYear,
    currAteRegion,
    currAteCity,
    currAteVC,
    currentLayerId,
    allChildren,
  } = useAppSelector((state) => state.layers);

  const dispatch = useAppDispatch();

  const handleChangeYear = (event: SelectChangeEvent) => {
    const year = event.target.value;
    dispatch(getToolbarSelectAction(isLogged, year));
  };

  useEffect(() => {
    if (needUpdate) {
      const clusterInfoVL =
        clusterInfo.info && foundPoints
          ? {
              gid: clusterInfo.gid,
              layerId: currentLayerId,
            }
          : undefined;

      dispatch(getToolbarSelectAction(isLogged, currentYear)).finally(() => {
        dispatch(
          langUpdateAteLayerAction(
            currAteRegion,
            currAteCity,
            currAteVC,
            false,
            clusterInfoVL
          )
        );
      });
    }
  }, [needUpdate]);

  useEffect(() => {
    dispatch(needUpdateAction(true));

    if (from !== 'layers') dispatch(resetCurrentsAteAction());
    dispatch(resetTransitionData('search'));
    dispatch(setEmptyStatisticsDataAction(false));

    return () => {
      dispatch(resetATEAction());
      // dispatch(resetCurrentsAteAction());

      //don't need
      // dispatch(resetAteListAction('ateCities', 'currAteCity')); //reset layers select options
      // dispatch(resetAteListAction('ateVC', 'currAteVC'));

      // dispatch(setCurrentLayerAction('', '', 0, '', '', ''));
      dispatch(resetFoundLayerAction());
      dispatch(resetDynamicSeries());
    };
  }, []);

  // for transit data
  useEffect(() => {
    const layer: any = allChildren.find((d) => d.id === currentLayerId);
    dispatch(
      setTransitionsData({
        dataset: Number(layer?.dataset || 0),
        ateRegion: Number(currAteRegion?.id || 0),
        ateRegionType: currAteRegion?.type,
        ateCity: Number(currAteCity?.id || 0),
        ateCityType: currAteCity?.type,
        layer: Number(currentLayerId || 0),
        ateVC: Number(currAteVC?.id || 0),
        from: 'search',
        needShowAte: false,
      })
    );
  }, [currAteRegion, currAteCity, currentLayerId, currAteVC]);

  return (
    <>
      <YearSelect
        years={years}
        currentYear={currentYear}
        handleChangeYear={handleChangeYear}
      />
      <AteBlock />
      <ParamName />
    </>
  );
};
